// removed by extract-text-webpack-plugin
module.exports = {"education":"_2uADm99J","edu-item":"_1DVqlVTE","eduItem":"_1DVqlVTE","course":"_2ZseXKKL","alma-mater":"_1hTHT5KQ","almaMater":"_1hTHT5KQ"};


//////////////////
// WEBPACK FOOTER
// ./src/views/ResumeView/Education/Education.pcss
// module id = 1011
// module chunks = 0